<div class="main-div">
    <div class="success-section">
        <div class="success-image inline-success">
            <img src="assets/img/success_picture.png" alt="success" class="success-img">
        </div>
        <div class="success-messages inline-success">
            <p class="success-message">{{confirmAccounts.successMessage}}</p>
            <p class="success-description">{{confirmAccounts.successDescription}}</p>
        </div>
        <!-- <p class="success-description">{{confirmAccounts.successDescription}}</p> -->
      </div>
    <div class="review-section">
        <p class="review-heading">{{confirmAccounts.enrollmentDetailsHeading}}</p> <br>
        <div class="review-info">
            <div class="first-block review-blocks">
                <div class="fan-info">
                    <app-customgrid [gridOptions]="gridOptions">
                        <ng-template let-row="row">
                               <li class="bullet-points bold-heading">{{row}}</li>
                        </ng-template>
                    </app-customgrid>
                </div>
                <div class="offer-types-info">
                    <p class="bold-heading offer-heading">Private Routing Offer Type</p>
                   <ul *ngFor = "let offer of enrolledData.serviceRequested">
                       <li class="bullet-points">{{offer}}</li>
                   </ul>
                </div>
            </div>
        </div>
        <br>
    </div>
    <br>
    <hr>
    <div class="contact-section">
        <p class="contact-heading">{{confirmAccounts.contactHeading}}</p>
        <p class="contact-fields email-field"><span class="bold-heading">{{confirmAccounts.phoneNumberLabel}}</span> {{enrolledData.customerPhoneNumber}}</p>
        <p class="contact-fields added-links"><span class="bold-heading">{{confirmAccounts.preferredEmail}}</span> {{enrolledData.emailAddress}}</p>
        <p class="contact-fields phone-field"><span class="bold-heading">{{confirmAccounts.preferredContactName}}</span> {{enrolledData.customerName}}</p>
        <p class="contact-fields phone-field"><span class="bold-heading">{{confirmAccounts.preferredContactNumber}}</span> {{enrolledData.alternateCustomerPhoneNumber}}</p>
        <p class="contact-fields phone-field"><span class="bold-heading">{{confirmAccounts.preferredTimeToContact}}</span> {{enrolledData.bestTimeToContact}}</p>
    </div>
    <br>
    <hr>
    <div class="submit-section">
        <button class="btn btn-secondary" id="requestEnrollment"(click)="gotoDashboard()">{{confirmAccounts.returnToDashboard}}</button>
    </div><br>
  </div>